import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {DialogDefinitionEditorBase} from '@shared/components/platform-tool/platform-tool-dialog-definition/models/dialog-defnition-models';
import {DialogService} from '@shared/services/dialog-service';
import {PlatformCommand} from '@shared/commands/command-base';
import {Api} from '@shared/constants/common-field.constants';
import {CommandService} from '@core/services/command.service';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';


@Component({
    standalone: false,
    selector: 'app-dialog-definition-dynamic-html-editor',
  templateUrl: './dialog-definition-dynamic-html-editor.component.html',
  styleUrls: ['./dialog-definition-dynamic-html-editor.component.scss']
})
export class DialogDefinitionDynamicHtmlEditorComponent extends DialogDefinitionEditorBase implements OnInit, AfterViewInit, OnDestroy {
  innerHtml = '';
  @ViewChild('InnerHtml') html: ElementRef;

  constructor(private dialogService: DialogService,
              private commandService: CommandService,
              private platformQueryService: PlatformQueryService,
              private fuseSplashScreenService: FuseSplashScreenService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    const emailBlastId = this.dialogField.fieldValues['EmailBlastId'];
    if (emailBlastId) {
      const query = new PlatformQuery();
      query.name = 'IndexHtmlTemplateUrlStatisticQuery';
      query.api = Api.TaxHubApi;
      query.setValue('EmailBlastId', this.dialogField.fieldValues['EmailBlastId']);
      this.fuseSplashScreenService.show();
      this.platformQueryService.executeQuery(query).subscribe(response => {
          this.fuseSplashScreenService.hide();
          this.innerHtml = response.fieldValues['InnerHtml'] ?? '';
          setTimeout(() => {
            const countElements = this.html.nativeElement.querySelectorAll('.url-hit-count');
            countElements.forEach(element => {
              element.addEventListener('click', this.onCountClick.bind(this, element.getAttribute('data-mapping-id'), element.getAttribute('data-email-blast-id')));
            });
          }, 500);
        },
        () => {
          this.fuseSplashScreenService.hide();
        });
    }
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  onCountClick(urlMappingId: string, emailBlastId: string) {
    const command = new PlatformCommand('UserDetailsByUrlMappingIdCommand', Api.TaxHubApi);
    command.setValue('UrlMappingId', urlMappingId);
    command.setValue('EmailBlastId', emailBlastId);
    this.commandService.executePlatformCommand(command).subscribe(res => {
      console.log(res);
    });
  }

  ngOnDestroy(): void {
    const countElements = this.html.nativeElement.querySelectorAll('.url-hit-count');
    countElements.forEach(element => {
      element.removeAllListeners();
    });
    super.ngOnDestroy();
  }
}
